export const AGENT = 'agent_ids';
export const BRANCH = 'branch_ids';
export const TEAM = 'team_ids';
export const TAG = 'tag_ids';
export const RANGE_DATE = 'range_date';
export const UPDATED_BUCKET = 'updated_bucket_ids';
export const AGENT_LABEL_KEY = 'full_name';
export const BRANCH_LABEL_KEY = 'name';
export const TEAM_LABEL_KEY = 'name';
export const TAG_LABEL_KEY = 'name';
export const RANGE_DATE_LABEL_KEY = 'text';
export const UPDATED_BUCKET_LABEL_KEY = 'text';

export const UPDATED_BUCKET_OPTIONS = [
  { id: '1_2', translationKey: '1To2Months' },
  { id: '2_3', translationKey: '2To3Months' },
  { id: '3_6', translationKey: '3To6Months' },
  { id: '6_12', translationKey: '6To12Months' },
  { id: '12_plus', translationKey: 'MoreThan12Months' },
];
